import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Container } from 'theme-ui'

import { WithTheme } from '../../../../setup/index'
import { transition } from '../../../../common/Mixins'
import media from '../../../../common/MediaQueries'

export const TabsStyled = styled.div``

export const TabsInnerStyled = styled.div``

export const TabsNavigationContainerStyled = styled(Container)`
  display: flex;
  flex-direction: column-reverse;
  margin-bottom: 2.125rem;

  @media ${media.tablet} {
    flex-direction: row;

    padding-left: 1.5625rem;
    padding-right: 1.5625rem;
    margin: 0 auto;
    max-width: 91.9375rem;
    width: 100%;
    margin-bottom: 8rem;
  }
`

export const TabsNavigationStyled = styled(Container)`
  display: flex;

  @media ${media.maxTablet} {
    width: 100%;
    justify-content: flex-start;
    overflow-x: auto;
    white-space: nowrap;

    -webkit-overflow-scrolling: touch;
    padding-left: 1.5625rem;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  @media ${media.tablet} {
    flex-direction: column;
  }
`

export const TabsNavigationSearchStyled = styled.div`
  @media ${media.maxTablet} {
    width: 100%;
    margin-bottom: 1rem;
  }
  @media ${media.tablet} {
    display: flex;
    align-items: flex-end;
    width: 20.875rem;
    padding-bottom: 1.5rem;
    ${({ theme }) => (theme.direction === 'rtl' ? ' margin-right: auto;' : ' margin-left: auto;')}
  }
`

export const TabsNavigationItemContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;

  ${({ theme }) => (theme.direction === 'rtl' ? 'direction: rtl;' : 'direction: ltr;')}

  @media ${media.tablet} {
    padding: 1rem 0;
  }

  @media ${media.desktop} {
    flex-direction: row;
  }
`

export const TabsNavigationItemStyled = styled.button<WithTheme>`
  ${transition}

  appearance: none;
  border-bottom: 0;
  border-radius: 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.green};
  background: transparent;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  width: 100%;
  padding: 0 10px;

  &:focus {
    outline: 0;
  }

  &::after {
    ${transition}
    position: relative;
    display: block;
    content: '';
    border-bottom: 0.125rem solid ${({ theme }) => theme.colors.green};
    transform: scaleX(0);
  }

  @media ${media.phone} {
    &:hover {
      &::after {
        transform: scaleX(1);
      }
    }
  }

  ${({ isActive, theme }) =>
    isActive &&
    css`
      /* color: ${theme.colors.green};
      opacity: 1;
      filter: grayscale(0); */
      &:after {
        transform: scaleX(1);
      }
    `};

  @media ${media.maxPhone} {
    &:not(:last-of-type) {
      margin-right: 0.125rem;
    }
  }
`

export const TabsNavigationItemIconStyled = styled.span`
  display: flex;
  align-items: center;
  height: 32px;

  @media ${media.desktop} {
    ${({ theme }) => (theme.direction === 'rtl' ? 'margin-left: 0.5rem;' : 'margin-right: 0.5rem;')}
  }
`

export const TabsContentStyled = styled(Container)``

export const TabsContentContainerStyled = styled.div`
  width: 100%;
  display: none;

  @media ${media.tablet} {
    width: auto;
    margin: 0 2.5rem;
  }

  @media ${media.desktop} {
    width: 100%;
    margin: 0 auto;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      display: block;
    `};
`

export const TabsContentItemStyled = styled.div`
  ${transition}
  transition-duration: 280ms;
  opacity: 0;
  width: 100%;
  margin: 0 auto;
`
